







import echarts, { EChartOption, graphic } from 'echarts'
import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import ResizeMixin from '@/components/Charts/mixins/resize'

const data = [
    [[66,58,'Application Stack'],
    [52,53,'Burp'],
    [90,85,'Cryptography'],
    [85,91,'Defense, Detection & Architecture'],
    [60,65,'Incident Response & Forensics'],
    [83,83,'Networking'],
    [39,32,'Nmap'],
    [112,94,'Security Hardening'],
    [56,60,'Vulnerability Management & Offensive Security']]
];

@Component({
  name: 'DifficultyTimeCorrChart'
})
export default class extends mixins(ResizeMixin) {
  @Prop({ default: 'chart' }) private className!: string
  @Prop({ default: '100%' }) private width!: string
  @Prop({ default: '300px' }) private height!: string

  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  }

  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  }

  private initChart() {
    this.chart = echarts.init(this.$el as HTMLDivElement, 'macarons')
    this.chart.setOption({
      title: {
          text: 'Est. and Avg. Time Spent Scatter Plot'
      },
      xAxis: {
          name: 'Est. Time (Mins)',
          nameLocation: 'middle',
          nameGap: 20,
          boundaryGap: false,
          axisTick: {
            show: false
          }
      },
      yAxis: {
          name: 'Time Spent (Mins)',
          nameLocation: 'middle',
          nameGap: 30,
          boundaryGap: false,
          axisTick: {
            show: false
          },
          scale: true
      },
      grid: {
        left: 30,
        right: 20,
        bottom: 20,
        top: 50,
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        },
        padding: 8
      },
      series: [{
          data: data[0],
          type: 'scatter',
          symbolSize: 20,
          label: {
              emphasis: {
                  show: true,
                  formatter: function(param: any) {
                      return param.data[2];
                  },
                  position: 'top'
              }
          },
          itemStyle: {
              normal: {
                  label: {
                    show: true,
                    position: 'top',
                    formatter: function(data: any) {
                      return data.value[2]
                    }
                  },
                  color: new graphic.LinearGradient(0, 0, 0, 1,
                  [
                      {offset: 0, color: '#e96443'},
                      {offset: 1, color: '#904e95'}
                  ])
              }
          },
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
      }]
    } as EChartOption<EChartOption.Series>)
  }
}
